import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, feedbackUrl, thriweDiscoveryUrl } from '../../../../../Containers/Config';
import { GET_FEEDBACK_LIST, GET_FEEDBACK_LIST_SUCCESS, GET_FEEDBACK_LIST_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* getFeedbackList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${feedbackUrl}/v1/admin/booking-feedback`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_FEEDBACK_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_FEEDBACK_LIST_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_FEEDBACK_LIST_ERROR, payload: error });
  }
}

export function* watchgetFeedbackList() {
  yield takeEvery(GET_FEEDBACK_LIST, getFeedbackList);
}

function* getFeedbackListSaga() {
  yield all([fork(watchgetFeedbackList)]);
}

export default getFeedbackListSaga;
